import * as z from "zod";

export const phraseBucketSchema = z.enum([
  "descriptor",
  "location",
  "action",
  "check",
  "finding",
  "disclaimer",
]);

export const phraseRecordSchema = z.object({
  id: z.string(),
  itemId: z.string(),
  actionPhraseId: z.string().nullish(),
  subItemIds: z.array(z.string()).optional(),
  bucketType: z.string(),
  sortOrder: z.number().optional(),
  phraseText: z.string(),
  defaultSelected: z.boolean().optional(),
  supportsNegation: z.boolean().optional(),
  supportsQualifier: z.boolean().optional(),
  defaultNegation: z.enum(["", "not", "no"]).nullish(),
  qualifierPosition: z.enum(["before_finding", "after_no"]).nullish(),
  scope: z.enum(["global", "org", "survey"]),
  organizationId: z.string().nullish(),
  surveyId: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const listPhrasesInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
});

export const listPhrasesResponseSchema = z.object({
  phrases: z.array(phraseRecordSchema),
});

export const createPhraseInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
  bucketType: phraseBucketSchema,
  phraseText: z.string().min(1),
  actionPhraseId: z.string().nullish().optional(),
  subItemIds: z.array(z.string()).optional(),
  supportsNegation: z.boolean().optional(),
  supportsQualifier: z.boolean().optional(),
  defaultNegation: z.enum(["", "not", "no"]).optional(),
  qualifierPosition: z.enum(["before_finding", "after_no"]).optional(),
  defaultSelected: z.boolean().optional(),
  sortOrder: z.number().optional(),
});

export const createPhraseResponseSchema = z.object({
  phrase: phraseRecordSchema,
});

export const updatePhraseInputSchema = z.object({
  organizationId: z.string(),
  phraseText: z.string().min(1).optional(),
  actionPhraseId: z.string().nullish().optional(),
  subItemIds: z.array(z.string()).optional(),
  supportsNegation: z.boolean().optional(),
  supportsQualifier: z.boolean().optional(),
  defaultNegation: z.enum(["", "not", "no"]).optional(),
  defaultSelected: z.boolean().optional(),
  qualifierPosition: z
    .enum(["before_finding", "after_no"])
    .nullish()
    .optional(),
  sortOrder: z.number().optional(),
});

export const updatePhraseResponseSchema = z.object({
  phrase: phraseRecordSchema,
});

export const deletePhraseInputSchema = z.object({
  organizationId: z.string(),
});

export const deletePhraseResponseSchema = z.object({
  ok: z.literal(true),
});

export const reorderPhrasesInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
  bucketType: phraseBucketSchema,
  phraseIds: z.array(z.string()).min(1),
});

export const reorderPhrasesResponseSchema = z.object({
  ok: z.literal(true),
});
